import { useEffect, useRef } from "react";
import styles from "./Loading.module.less";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
export const MikeLoading = () => {
  const { setIsAuthLoading } = useAuthenticationContext();

  const authTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    authTimeoutRef.current = setTimeout(() => {
      setIsAuthLoading(false);
    }, 1000);

    return () => {
      if (authTimeoutRef.current) {
        clearTimeout(authTimeoutRef.current);
      }
    };
  }, [setIsAuthLoading]);

  return (
    <>
      <div className={styles.loading}>
        <img src="/mike_loading_colored.gif" alt="" width={400} />

        <div className={styles.loadingText}>
          <span>L</span>
          <span>O</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
        </div>
      </div>
    </>
  );
};

export default MikeLoading;
